import * as React from 'react'
import Header from '../structure/Header/Header'
import Footer from '../structure/Footer/Footer'
require('./suppression.css')

/*
    this class is the page "suppressiondonnees".
    you can choose the formula you want yo delete your data on other website.
*/
export default class Accueil extends React.Component {

	render() {
		return (
			<>	
				<div id="other_canv">
					<div id="particles-js">
					<Header/>
					<div className="hero-wrap js-fullheight">
						<div className="overlay">
						</div>
							<div className="container">
								<div className="row no-gutters slider-text align-items-center justify-content-center" data-scrollax-parent="true">
									<div id="border-search" className="col-md-6 ftco-animate text-center fadeInUp ftco-animated" data-scrollax=" properties: { translateY: '70%' }">
										<br></br>
										<br></br>
										<h1 className="mb-3 bread" data-scrollax="properties: { translateY: '30%', opacity: 1.6 }">
											Suppression de vos données personnelles
										</h1>
									</div>
								</div>
							</div>
						</div>
					</div>
				<section>
					<div className="container">
						<div id="text_supp">
							<div>
								<div id="content_supp">
									<span className="subheading">Nous supprimons vos données personnelles des sites</span>
									<h2 className="mb-10">Comment ça marche ?</h2>
                                    <br></br>
                                    <br></br>
                                    <p>
                                        Une fois que vous aurez sélectionné votre formule, nous vous redirigerons sur une page où vous pourrez sélectionner les sites où vous souhaitez supprimer vos données.
                                    </p>
                                    <br></br>
                                    <p>
                                        Suite à ça, nous mettons à disposition un mandat, qui nous permettra de faire une demande de supression de vos données personnelles auprès des sites que vous avez sélectionner.
                                    </p>
                                    <br></br>
                                    <p>
                                        Un délai peut s'appliquer entre le moment du paiement et le résultat escompté. Un suivi de votre demande sera créé et mis à jour dès que nous aurons des nouvelles de la part de ces sites.
                                    </p>
                                    <br></br>
                                    <p>
                                        Si le délai devient trop important pour un site, nous vous enverrons un mail pour vous signaler une atteinte à la RGPD de la part de ce même site et nous vous proposerons donc de vous tourner vers les autorités compétentes.   
                                    </p>
								</div>
							</div>
						</div>
                        <div>
                            <br></br>
                            <br></br>
                            <div id="nav_supp">
                                <div className="[ price-option price-option--low ]">
                                    <div className="price-option__detail">
                                        <span className="price-option__cost">FREE</span>
                                        <span className="price-option__type">1 site</span>
                                    </div>
                                    {
                                        localStorage.getItem('AccessToken') !== null 
                                            ? <a className="price-option__purchase" href="/selectionsite1">Sélectionner</a>
                                            : <a className="price-option__purchase" href="#/">Veuillez vous connecter pour accéder à ce service</a>
                                    }
                                </div>
                                <div className="[ price-option price-option--mid ]">
                                    <div className="price-option__detail">
                                        <span className="price-option__cost">FREE</span>
                                        <span className="price-option__type">10 sites</span>
                                    </div>
                                    {
                                        localStorage.getItem('AccessToken') !== null 
                                            ? <a className="price-option__purchase" href="/selectionsite2">Sélectionner</a>
                                            : <a className="price-option__purchase" href="#/">Veuillez vous connecter pour accéder à ce service</a>
                                    }
                                </div>
                                {/* <div className="[ price-option price-option--high ]">
                                    <div className="price-option__detail">
                                        <span className="price-option__cost">19.99€</span>
                                        <span className="price-option__type">30 sites</span>
                                    </div>
                                    <a className="price-option__purchase" href="/selectionsite3">
                                        Sélectionner
                                    </a>
                                </div> */}
                            </div>
						</div>
					</div>
				</section>
				
				<Footer/>
				</div>
			</>
		);
	}

}